import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

export class ProductSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  initSwiper() {
    // Wait for the DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.createSwiper());
    } else {
      this.createSwiper();
    }
  }

  createSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper");
    if (!swiperWrapper) {
      console.warn("Swiper wrapper not found");
      return;
    }

    const slides = this.querySelectorAll(".swiper-slide");

    if (slides.length === 0) {
      console.warn("No slides found");
      return;
    }

    // Add swiper class to the component
    this.classList.add("swiper");

    this.swiper = new Swiper(this, {
      // Enable fade effect
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },

      // Basic settings
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 600,

      // Autoplay
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },

      // Navigation
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    console.log("Swiper configuration complete");
  }
}

customElements.define("product-slider-component", ProductSliderComponent);
